import pdfApi from '../../../Api/pdfApi';

let pdfBoardCache = null;

export const initializePdfUpload = async (fileName, pageCount, collectionId = null) => {
    try {
        const response = await pdfApi.createPdfBoard(fileName, pageCount, collectionId);
        pdfBoardCache = response.data;
        return pdfBoardCache;
    } catch (error) {
        console.error('Error initializing PDF upload:', error);
        throw error;
    }
};

export const uploadPdfFile = async (pdfFile) => {
    try {
        if (!pdfBoardCache) {
            throw new Error('PDF board not initialized. Call initializePdfUpload first.');
        }

        const result = await pdfApi.uploadPdfFile(pdfBoardCache.pdfUrl, pdfFile);

        console.log('PDF file uploaded successfully');
        console.log(`Download URL: ${result.download}`);

        return {
            pdfUrl: result.download,
        };
    } catch (error) {
        console.error('Error uploading PDF file to GCS:', error);
        throw error;
    }
};

export const uploadThumbnail = async (thumbnailBlob, pageNumber) => {
    try {
        if (!pdfBoardCache) {
            throw new Error('PDF board not initialized. Call initializePdfUpload first.');
        }

        const urlPair = pdfBoardCache.thumbnailUrls.find((u) => u.pageNumber === pageNumber);
        if (!urlPair) {
            throw new Error(`No signed URL found for page ${pageNumber}`);
        }

        const result = await pdfApi.uploadThumbnail(urlPair, thumbnailBlob);

        console.log(`Thumbnail ${pageNumber} uploaded successfully`);
        console.log(`Thumbnail URL: ${result.thumbnailDownload}`);

        return {
            pageNumber,
            thumbnailUrl: result.thumbnailDownload,
        };
    } catch (error) {
        console.error('Error uploading thumbnail to GCS:', error);
        throw error;
    }
};

export const clearPdfBoardCache = () => {
    pdfBoardCache = null;
};

export const getPdfBoardId = () => {
    return pdfBoardCache?.boardId || null;
};
